<template>

    <Page>

        <ImageAndText 
            animation="zoom"
            src="/Challenge/solution.png"
            border
            image-class="rounded-xl"
            floor-shadow>

            <h2 class="mb-4">Legacy retention programs don't go far enough</h2>
            <p class="font-normal text-white/80">
                Most so-called retention programs offer superficial value—focused more on 
                upselling than truly keeping customers loyal. They've lost sight of their 
                original purpose: genuine retention.
            </p>

            <p class="font-normal text-white/80 mt-3">
                But what if you could protect your hard-earned goodwill, ensure long-term 
                revenue, and increase your upfront returns—all in one program?
            </p>

        </ImageAndText>

        <KeyMessage animate>
            It's time to rethink retention. Not as a marketing add-on, but as a strategic investment in loyalty, trust and profitability
        </KeyMessage>

    </Page>

</template>